import Text from '@components/common/text';
import CustomImage from '@components/common/image';
import Icon from '@components/common/assets';
import { useRecruitmentUrl } from '@repository/recruitment/useRecruitment';
import { LogTypeEnum } from '@/src/logging/LogType';
import ApplyBtn from './applyBtn';
import ApplyModals from '../../../../../common/modalsWrap';
import MatchingHomePositionCardVO from '@domain/vo/match/ApplicationPositionVO';

import { dummyImgSrc } from '@domain/constant/img/positionDummyImgSrc';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import { PageTypeEnum } from '@domain/constant/match/profile/pageType';
import useMessageModal from '@utils/hooks/useMessageModal';
import useModals from '@utils/hooks/useModals';
import DateFormat from '@utils/date/format';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface ItemProps {
  data: MatchingHomePositionCardVO;
  refetch: () => void;
}
const Item = ({ data, refetch }: ItemProps) => {
  const {
    positionSn,
    companyName,
    positionName,
    positionType,
    enableInsightMypage,
    matchingOfferYn,
    jobApplicationProcessType,
    jobApplicationProcessText,
    applicationCompleteTime,
    companyLogoUrl,
  } = data;

  const { mutateAsync: fetchRecruitmentDomain } = useRecruitmentUrl(({ url }) => {
    if (url) window.open(url);
  });

  const { openMessageModal } = useMessageModal();
  const isJobdaPosition = positionType === 'JOBDA';
  const { openModal, modalState, closeModal } = useModals([
    'RESUME_DELETE',
    'RESUME_SAVE',
    'APPLY_CANCEL',
    'RESUME_END',
    'POSITION_END',
  ] as const);

  const onClickCard = () => {
    if (isJobdaPosition) onOpenMessage();
    else handleInsightCard();
  };

  const handleInsightCard = () => {
    if (enableInsightMypage) fetchRecruitmentDomain({ positionSn, pageType: PageTypeEnum.MY_PAGE });
    else openModal('POSITION_END');
  };

  const onOpenMessage = () => {
    openMessageModal(positionSn);
  };

  return (
    <>
      <button className={cx('wrapper')} onClick={onClickCard} id={LogTypeEnum.log_apply_position_card}>
        <div className={cx('column', 'column1')}>
          <CustomImage
            className={cx('img')}
            src={companyLogoUrl ?? dummyImgSrc}
            alt="companyLogo"
            width={48}
            height={48}
            ErrorImage={
              <CustomImage className={cx('img')} src={dummyImgSrc} alt="companyLogo" width={48} height={48} />
            }
          />
          <div className={cx('infoArea')}>
            <div className={cx('positionName')}>
              {matchingOfferYn && (
                <Text fontStyle={FontStyle.B3P_B} color={Colors.C_GREEN_200}>
                  매칭 제안
                </Text>
              )}
              <Text fontStyle={FontStyle.B3P_B} ellipsis styles={{ maxWidth: 454 }}>
                {positionName}
              </Text>
              {positionType === 'HOMEPAGE' && (
                <Icon name="openInNewLight" width={24} height={24} fill={Colors.C_COOL_GRAY_60} />
              )}
            </div>
            <Text fontStyle={FontStyle.B4P_M} color={Colors.C_COOL_GRAY_70}>
              {companyName}
            </Text>
          </div>
        </div>

        <div className={cx('column', 'column2')}>
          {applicationCompleteTime ? DateFormat.format(new Date(applicationCompleteTime), 'yyyy.MM.dd') : '-'}
        </div>

        <div className={cx('column', 'column3', jobApplicationProcessType)}>{jobApplicationProcessText}</div>

        <div>
          <ApplyBtn
            positionSn={positionSn}
            statusType={jobApplicationProcessType}
            isJobdaPosition={isJobdaPosition}
            openModal={openModal}
            refetch={refetch}
          />
        </div>
      </button>

      <ApplyModals
        positionSn={positionSn}
        modalState={modalState}
        onClose={closeModal}
        openModal={openModal}
        confirmAfter={refetch}
      />
    </>
  );
};

export default Item;
